import * as React from 'react';
import * as Modal from 'react-modal';
import { IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Preloader } from '@cian/preloader-component';
import { IconClose } from './icons';
import { SubscriptionForm } from '../subscription_form';
import * as styles from './subscription_popup.css';
import { ICreateSubscriptionRequest } from '../../../repositories/monolith-python/v1/create-subscription';

export interface ISubscriptionPopupProps {
  offer: IOfferSchema;
  user: IUserSchema | null;
  isOpen: boolean;
  isLoad: boolean;
  isSubscribe: boolean;
  globalError?: string;
  isAuthenticated: boolean;
  pushSubscribed: boolean;
  onClose(): void;
  fetchCreateSubscription(parameters: ICreateSubscriptionRequest): Promise<void>;
}

export class SubscriptionPopup extends React.Component<ISubscriptionPopupProps, {}> {
  public render() {
    const { isLoad, isSubscribe, user, offer, globalError, pushSubscribed, fetchCreateSubscription } = this.props;

    return (
      <Modal
        isOpen={this.props.isOpen}
        ariaHideApp={false}
        onRequestClose={this.onClose}
        style={{
          content: {
            overflow: 'visible',
            padding: '0',
            position: 'static',
            width: '545px',
            zIndex: 101,
          },
          overlay: {
            // stylelint-disable-line
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          },
        }}
      >
        <div className={styles['container']}>
          {isLoad && (
            <div className={styles['preloader']}>
              <Preloader size={32} />
            </div>
          )}
          <button type="button" className={styles['close']} onClick={this.onClose}>
            <IconClose />
          </button>
          <h3 className={styles['title']}>
            {isSubscribe ? (
              <span>
                Поиск сохранён <span className={styles['emoji']}>😊</span>
              </span>
            ) : (
              'Сохранение поиска'
            )}
          </h3>
          <SubscriptionForm
            isSubscribe={isSubscribe}
            offer={offer}
            user={user}
            globalError={globalError}
            isLoad={isLoad}
            pushSubscribed={pushSubscribed}
            fetchCreateSubscription={fetchCreateSubscription}
          />
        </div>
      </Modal>
    );
  }

  private onClose = () => {
    this.setState({
      titleInputInvalid: false,
      emailInputInvalid: false,
      emailError: '',
    });

    this.props.onClose();
  };
}
